import { Component, OnInit } from '@angular/core';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { Router } from '@angular/router';
import { configuracion } from '../../recursos/config.service';

@Component({
  selector: 'app-herader-operario',
  templateUrl: './herader-operario.component.html',
  styleUrls: ['./herader-operario.component.css']
})
export class HeraderOperarioComponent implements OnInit {

  public usuario: string;
  public vecRoles = [];
  public selectRol: number = 1;

  constructor(private tools: ToolsService, private srvSelect: SeleccionService, private ruta: Router, private conf: configuracion) { }

  ngOnInit() {
    // localStorage.setItem('ciUsuario', '0604120550'); localStorage.setItem('idUser', '18');
    if (localStorage.getItem("localCargar") == "0") {
      window.location.reload();
      localStorage.setItem("localCargar", "1");
    }
    else {
      if (localStorage.getItem('ciUsuario') == null || localStorage.getItem('ciUsuario') == "" || localStorage.getItem('idUser') == null || localStorage.getItem('idUser') == "") {
        this.salirBecas();
      }
      else {
        this.tools.ColorUsuario(4);
        this.verificarRol(localStorage.getItem('ciUsuario'));
        this.selectRol = Number.parseInt(localStorage.getItem("idUser"));
      }
    }
  }

  verificarRol(user: string) {
    this.srvSelect.gestionRoles(2, user, localStorage.getItem("idUser")).subscribe(res => {
      if (res.success) {
        this.usuario = res.roles[0]['strCorreo'];
        localStorage.setItem('localNombUsuario', res.roles[0]['strNombres'] + " " + res.roles[0]['strApellidos']);
        localStorage.setItem('userAudita', res.roles[0]['intIdPersona']);
        localStorage.setItem('idPersona', res.roles[0]['intIdPersona']);
        this.datosUsuario(user);
      }
      else
        this.salirBecas();
    });
  }
  datosUsuario(user: string) {
    this.srvSelect.gestionRoles(1, user, "na").subscribe(res => {
      if (res.success) {
        for (let i in res.roles) {
          if (localStorage.getItem("idUser") == res.roles[i]['intIdRol'])
            localStorage.setItem('perfilAudita', res.roles[i]['NombreRol']);
          this.vecRoles.push({
            idTipo: res.roles[i]['intIdRol'], descripcion: res.roles[i]['NombreRol']
          });
        }
      }
      else
        this.salirBecas();
    });
  }

  cambiaRol() {
    localStorage.setItem("localCargar", "0");
    this.ruta.navigate([this.conf.cambiaRol(this.selectRol)]);
    if (this.conf.cambiaRol(this.selectRol) == "../gestion")
      window.location.reload();
  }
  salirBecas() {
    this.remove();
    this.ruta.navigate(['/']);
  }
  public remove() {
    window.sessionStorage.removeItem('ticketUser');
    window.sessionStorage.removeItem('loginUser');
    window.sessionStorage.removeItem('clientName');
  }
}

